export type Consent = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  ts: number;
};

export const CONSENT_KEY = "helio.cookieConsent";
export const CONSENT_EVENT = "helio:consent";
export const OPEN_PREFERENCES_EVENT = "helio:open-cookie-preferences";

export function readConsent(): Consent | null {
  if (typeof window === "undefined") return null;
  const raw = window.localStorage.getItem(CONSENT_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Consent;
    if (parsed.necessary !== true) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeConsent(c: Omit<Consent, "ts" | "necessary">) {
  const v: Consent = { ...c, necessary: true, ts: Date.now() };
  window.localStorage.setItem(CONSENT_KEY, JSON.stringify(v));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: v }));
  syncWindowConsent(v);
  return v;
}

export function syncWindowConsent(consent: Consent | null = readConsent()) {
  if (typeof window === "undefined") return;
  (window as Window & { helioConsent?: { analytics: boolean; marketing: boolean } }).helioConsent =
    consent
      ? { analytics: consent.analytics, marketing: consent.marketing }
      : { analytics: false, marketing: false };
}

export function openCookiePreferences() {
  window.dispatchEvent(new CustomEvent(OPEN_PREFERENCES_EVENT));
}

if (typeof window !== "undefined") {
  syncWindowConsent();
}
